// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qK9Z","top":"styles_top__21pcX"};